export const enum EntryMode {
    Create = 1,
    Edit = 2,
    Display = 0,
}
export interface DistanceBand
{
    id       : number, 
    minValue : number,
    maxValue : number,
    amount   : number
}
export interface PutDistanceBand {
    id      : number,
    minValue: number,
    maxValue: number,
    amount  : number
    mode    : EntryMode
}

export interface DecisionTable {
    id           : number,
    name         : string,
    description  : string,
    distanceBands: DistanceBand[]
}
export interface PostDecisionTable
{
    name         : string,
    description  : string,
    distanceBands: PutDistanceBand[]
}
export interface PutDecisionTable
{
    id           : number,
    name         : string,
    description  : string,
    distanceBands: PutDistanceBand[]
}